import { ComboField } from '@components/Fields/ComboField';
import { FixedFilterPanel } from '@components/FixedFilterPanel';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IFilter } from '@hooks/useFilter';
import { MenuItem } from '@material-ui/core';
import { EnumEmpresa, IComboEmpresa } from '@model/Empresa';
import { IInadimplenciaFilter } from '@services/RelatorioService';
import React from 'react';

export type InadimplenciaFilterProps = {
    filter: IFilter<IInadimplenciaFilter>
    isLoading: boolean
    empresaCombo: IComboEmpresa
}

export function InadimplenciaFilter ({ filter, isLoading, empresaCombo }: InadimplenciaFilterProps) {
    const handleReset = React.useCallback(() => {
        filter.resetFilter();
    }, [filter]);

    return (
        <FixedFilterPanel
            onSearch={filter.handleFilterRequest}
            onClear={handleReset}
            disabled={isLoading}
        >
            <HorizontalGrid spacing={1}>
                <GridItem xs={2}>
                    <ComboField
                        field={filter.fields.empresaId}
                        label="Empresa"
                        onEnter={filter.handleFilterRequest}
                        fullWidth
                        disabled={isLoading}
                        InputLabelProps={{
                            shrink: true
                        }}
                    >
                        <MenuItem key={0} value={EnumEmpresa.None}>Todas</MenuItem>
                        {
                            empresaCombo.createOptions()
                        }
                    </ComboField>
                </GridItem>
            </HorizontalGrid>
        </FixedFilterPanel>
    )
}